"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var themes_1 = require("./themes");

exports.getColor = function (props, skipDefault) {
  var color = getBaseColor(props, skipDefault);
  return color && adjustColor(color, props);
};

var getBaseColor = function getBaseColor(props, skipDefault) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;

  if (props.color) return props.color;

  if (props.raised) {
    if (props.primary) return _d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.onColor, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.colors.primary.onColor;
    if (props.secondary) return _h = (_g = (_f = (_e = props.theme) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.secondary) === null || _g === void 0 ? void 0 : _g.onColor, _h !== null && _h !== void 0 ? _h : themes_1.defaultTheme.colors.secondary.onColor;
    return _m = (_l = (_k = (_j = props.theme) === null || _j === void 0 ? void 0 : _j.colors) === null || _k === void 0 ? void 0 : _k.default) === null || _l === void 0 ? void 0 : _l.onColor, _m !== null && _m !== void 0 ? _m : themes_1.defaultTheme.colors.default.onColor;
  } else {
    if (props.primary) return _r = (_q = (_p = (_o = props.theme) === null || _o === void 0 ? void 0 : _o.colors) === null || _p === void 0 ? void 0 : _p.primary) === null || _q === void 0 ? void 0 : _q.color, _r !== null && _r !== void 0 ? _r : themes_1.defaultTheme.colors.primary.color;
    if (props.secondary) return _v = (_u = (_t = (_s = props.theme) === null || _s === void 0 ? void 0 : _s.colors) === null || _t === void 0 ? void 0 : _t.secondary) === null || _u === void 0 ? void 0 : _u.color, _v !== null && _v !== void 0 ? _v : themes_1.defaultTheme.colors.secondary.color;
    return skipDefault ? null : (_z = (_y = (_x = (_w = props.theme) === null || _w === void 0 ? void 0 : _w.colors) === null || _x === void 0 ? void 0 : _x.default) === null || _y === void 0 ? void 0 : _y.color, _z !== null && _z !== void 0 ? _z : themes_1.defaultTheme.colors.default.color);
  }
};

exports.getBackgroundColor = function (props) {
  var _a, _b, _c, _d, _e, _f;

  return _f = (_a = exports.getBackgroundColorWithoutDefault(props), _a !== null && _a !== void 0 ? _a : (_e = (_d = (_c = (_b = props) === null || _b === void 0 ? void 0 : _b.theme) === null || _c === void 0 ? void 0 : _c.colors) === null || _d === void 0 ? void 0 : _d.default) === null || _e === void 0 ? void 0 : _e.color), _f !== null && _f !== void 0 ? _f : themes_1.defaultTheme.colors.default.color;
};

exports.getBackgroundColorWithoutDefault = function (props) {
  var color = getBaseBackgroundColor(props);
  return color && adjustColor(color, props);
};

var getBaseBackgroundColor = function getBaseBackgroundColor(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  if ((_a = props) === null || _a === void 0 ? void 0 : _a.backgroundColor) return props.backgroundColor;
  if ((_b = props) === null || _b === void 0 ? void 0 : _b.background) return props.background;
  if (props && !props.raised) return 'transparent';
  if ((_c = props) === null || _c === void 0 ? void 0 : _c.primary) return _g = (_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.colors) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.color, _g !== null && _g !== void 0 ? _g : themes_1.defaultTheme.colors.primary.color;
  if ((_h = props) === null || _h === void 0 ? void 0 : _h.secondary) return _m = (_l = (_k = (_j = props.theme) === null || _j === void 0 ? void 0 : _j.colors) === null || _k === void 0 ? void 0 : _k.secondary) === null || _l === void 0 ? void 0 : _l.color, _m !== null && _m !== void 0 ? _m : themes_1.defaultTheme.colors.secondary.color;
  return null;
};

var adjustColor = function adjustColor(color, props) {
  var _a, _b;

  if ((_a = props) === null || _a === void 0 ? void 0 : _a.darken) {
    return polished_1.darken(typeof props.darken === 'number' ? props.darken : 0.2, color);
  }

  if ((_b = props) === null || _b === void 0 ? void 0 : _b.lighten) {
    return polished_1.lighten(typeof props.lighten === 'number' ? props.lighten : 0.2, color);
  }

  return color;
};